<template>
  <div ref="modal" class="modal" tabindex="-1">
    <div
      :class="`modal-dialog ${size} ${
        scrollable ? 'modal-dialog-scrollable' : ''
      }`"
    >
      <div class="modal-content position-relative">
        <button
          type="button"
          class="close btn-close detail-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <IconClose class="white" />
        </button>
        <div class="modal-body">
          <slot />
        </div>
        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '../../../../templates/icons/close.svg';

export default {
  components: {
    IconClose,
  },
  props: {
    value: {
      type: Boolean,
    },
    // https://getbootstrap.com/docs/4.6/components/modal/#optional-sizes
    // modal-sm, modal-lg, modal-xl
    size: {
      type: String,
      default: '',
    },
    // https://getbootstrap.com/docs/4.6/components/modal/#scrolling-long-content
    scrollable: {
      type: Boolean,
    },
  },
  data() {
    return {
      $modal: null,
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.$modal.show();
      } else {
        this.$modal.hide();
      }
    },
  },
  mounted() {
    if (typeof window === 'object') {
      // Retrieve/instantiate Bootstrap modal
      this.$modal = new window.bootstrap.Modal(this.$refs['modal']);
      // Emit when modal gets closed using a Bootstrap trigger
      this.$refs['modal'].addEventListener('hide.bs.modal', () => {
        this.$emit('input', false);
      });
    }
  },
};
</script>
